module.exports = __webpack_public_path__ + "static/the-jack-tales-f3a4a1efb96398f2a131b9af8e6f4bb1.jpg";